// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./TotalCostStyles";
// @otg-one/ui_components/components
import { Button, Typography } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Lib
import moment from 'moment';
import { formatNumericalWithThousandSeparator } from "../../utils/Utils";
export const TotalCost = (props) => {
    const classes = useStyles(props);
    const { id, totalCost, actionHandler, textTotalCostThisMonth, textGoToBilling, style, textBilledOn } = props;
    return (React.createElement("div", { id: `${id}-total-cost-container`, className: classes.totalCostContainer, style: style },
        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: Color.neutral[100] }, textTotalCostThisMonth),
        React.createElement("div", { id: `${id}-total-cost`, className: classes.totalCost },
            (totalCost === null || totalCost === void 0 ? void 0 : totalCost.price) || (totalCost === null || totalCost === void 0 ? void 0 : totalCost.price) === 0 && React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 56, color: Color.neutral[0] }, `${formatNumericalWithThousandSeparator(totalCost === null || totalCost === void 0 ? void 0 : totalCost.price)} €`),
            (totalCost === null || totalCost === void 0 ? void 0 : totalCost.textBilledDate) && React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_ITALIC, size: 12, color: Color.neutral[0] }, textBilledOn + ` ${moment(totalCost === null || totalCost === void 0 ? void 0 : totalCost.textBilledDate).format("DD MMMM YYYY")}`)),
        actionHandler &&
            React.createElement(Button, { id: `${id}-total-price-box-button`, type: "secondary", color: "white", alignIcon: "right", style: { marginTop: 20 }, onClick: actionHandler }, textGoToBilling)));
};
TotalCost.defaultProps = {
    totalCost: {
        price: 1470,
        textBilledDate: "31 January 2019"
    },
    textTotalCostThisMonth: 'Total Cost This Month',
    textGoToBilling: 'Go to Billing',
    textBilledOn: 'Billed on'
};
export default React.memo(TotalCost);
